import React from 'react';
import './SkeletonLoader.css';

export const BlogSkeleton = ({ count = 6 }) => (
  <div className="blog-skeleton">
    {/* Header */}
    <div className="blog-skeleton-header">
      <div className="skeleton blog-skeleton-label" />
      <div className="skeleton blog-skeleton-title" />
      <div className="skeleton blog-skeleton-title-secondary" />
    </div>

    {/* Search */}
    <div className="skeleton blog-skeleton-search" />

    {/* Filters */}
    <div className="blog-skeleton-filters">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="skeleton blog-skeleton-filter" />
      ))}
    </div>

    {/* Featured Post */}
    <div className="blog-skeleton-featured">
      <div className="skeleton blog-skeleton-featured-image" />
      <div className="blog-skeleton-featured-content">
        <div className="blog-skeleton-featured-meta">
          <div className="skeleton blog-skeleton-featured-badge" />
          <div className="skeleton blog-skeleton-featured-date" />
        </div>
        <div className="skeleton blog-skeleton-featured-title" />
        <div className="skeleton blog-skeleton-featured-title-2" />
        <div className="skeleton blog-skeleton-featured-excerpt" />
        <div className="skeleton blog-skeleton-featured-excerpt-2" />
        <div className="skeleton blog-skeleton-featured-link" />
      </div>
    </div>

    {/* Grid */}
    <div className="blog-skeleton-grid">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="blog-skeleton-card">
          <div className="skeleton blog-skeleton-card-image" />
          <div className="blog-skeleton-card-content">
            <div className="blog-skeleton-card-meta">
              <div className="skeleton blog-skeleton-card-badge" />
              <div className="skeleton blog-skeleton-card-date" />
            </div>
            <div className="skeleton blog-skeleton-card-title" />
            <div className="skeleton blog-skeleton-card-title-2" />
            <div className="skeleton blog-skeleton-card-excerpt" />
            <div className="skeleton blog-skeleton-card-link" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Simple card skeleton for homepage sections
export const CardSkeleton = ({ count = 3 }) => (
  <div className="card-skeleton-grid">
    {[...Array(count)].map((_, i) => (
      <div key={i} className="card-skeleton">
        <div className="skeleton card-skeleton-image" />
        <div className="card-skeleton-content">
          <div className="skeleton card-skeleton-badge" />
          <div className="skeleton card-skeleton-title" />
          <div className="skeleton card-skeleton-title-2" />
          <div className="skeleton card-skeleton-excerpt" />
        </div>
      </div>
    ))}
  </div>
);

export const BlogDetailSkeleton = () => (
  <div className="blog-detail-skeleton">
    {/* Header */}
    <div className="blog-detail-skeleton-header">
      <div className="skeleton blog-detail-skeleton-category" />
      <div className="skeleton blog-detail-skeleton-title" />
      <div className="skeleton blog-detail-skeleton-title-2" />
      <div className="blog-detail-skeleton-meta">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="skeleton blog-detail-skeleton-meta-item" />
        ))}
      </div>
    </div>

    {/* Share */}
    <div className="blog-detail-skeleton-share">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="skeleton blog-detail-skeleton-share-btn" />
      ))}
    </div>

    {/* Image */}
    <div className="skeleton blog-detail-skeleton-image" />

    {/* Content */}
    <div className="blog-detail-skeleton-content">
      {[...Array(15)].map((_, i) => (
        <div 
          key={i} 
          className={`skeleton blog-detail-skeleton-paragraph ${
            i % 3 === 0 ? 'short' : i % 3 === 1 ? 'medium' : ''
          }`} 
        />
      ))}
    </div>
  </div>
);
